import axios from 'axios';

const clearCookie = (name) => {
  document.cookie = `${name}=; Max-Age=0; path=/;`;
};

const useAxios = () => {
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true
  });

  let hasLoggedOut = false;

  // 🔐 Request interceptor
  axiosInstance.interceptors.request.use(
    (config) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; access_token=`);
      if (parts.length === 2) {
        const token = parts.pop().split(';').shift();
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // ⚠️ Response interceptor
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        !error.response ||
        !error.response.config ||
        ['/auth/login', '/users/me'].some((path) => error.response.config.url?.includes(path))
      ) {
        return Promise.reject(error);
      }

      console.log('Error on:', error.response.config.url);

      if (!hasLoggedOut && error.response.status === 401) {
        hasLoggedOut = true;
        const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        const signInPath = '/authentication/sign-in/basic';

        if (currentPath !== signInPath) {
          sessionStorage.setItem('postLoginRedirect', currentPath);
        }

        clearCookie('access_token');
        window.dispatchEvent(new Event('tokenExpired'));
        window.location.assign(signInPath);
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default useAxios;
